export default "__VITE_ASSET__b773defe__"